<template>
    <div id="listCustomers">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">{{contactPageData.pageTitle}}</div>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_cust btn general-button btn-primary" v-on:click="allClickCustomer()">All </button>
                        <button type="button" class="btn_my_cust btn general-button btn-secondary" v-on:click="myClickCustomer()">My Self</button>

                        <button type="button" class="btn general-button btn-primary icon-btn ml-1" v-on:click="refreshCustomer()"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="customerList"
                                        ref="listCustomerTable"
                                        mode="remote"
                                        title="Customers"
                                        @on-page-change="onPageChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-row-click="onRowClick"
                                        :totalRows="totalRecords"
                                        :columns="columns"
                                        :rows="rows"
                                        :selectOptions="{
                                        //enabled: true,
                                        //selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        //selectionInfoClass: 'custom-class',
                                        //selectionText: 'rows selected',
                                        //clearSelectionText: 'clear',
                                        }"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParams.perPage,
                                        setCurrentPage: serverParams.setCurrentPage,
                                        perPageDropdown: customPerPageArr,
                                        dropdownAllowAll: false,
                                        }"

                                        :search-options="{
                                        enabled: false,
                                        }">
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm">
                                    <div  class="row">
                                        <div class="col-md-2 col-sm-12 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParams.perPage"
                                                      @change="changedValue"
                                                      @input="changedValueCustomPerPage()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="customPerPageArr"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-md-2 col-sm-12 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRows}} of {{totalRecords}}</p>
                                        </div>
                                        <div class="col-md-6 col-sm-12 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClick(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberList() < displayPage">
                                                    <template v-for="(n, index) in pageNumberList()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParams.page) <= pageCompare">
                                                        <template v-for="(n, index) in displayPage">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParams.page) >= (pageNumberList() - (pageCompare-1))">
                                                        <template v-for="(n, index) in pageNumberList()">
                                                            <template v-if="n > (pageNumberList() - displayPage)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberList()" v-if="(n >= (Number(serverParams.page) - (pageCompare -1))) && (n <= (Number(serverParams.page) + (pageCompare -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClick(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(pageNumberList())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input v-model="jumpToPage" type="text" class="form-control form-control-sm" name="jumpToPage" id="jumpToPage" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'" >
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_see_customer_view'" v-for="(permission, index) in permissions">
                                            <router-link class="btn edit-btn-vvg waves-effect" title='View customer details' v-bind:to="{name: 'CustomerView',params:{id:props.row.id}}"><i class="fa fa-eye"></i></router-link>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions" slot-scope="computed">
                                {{computed.selectedRows}}
                                <button v-on:click="sendMail" title='Mail' >Mail</button>
                            </div>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>


    // import { headers } from "../config";
    import {list_customerUrl, configs} from '../../config';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    const Swal = require('sweetalert2');

    Vue.use(VueGoodTable);

    export default {
        name: "listCustomercomponent",
        mixins: [SessioMixin],
        props: {
            contactPageData: '',
        },
        data: () => ({
                displayPage: 7,
                pageCompare: 0,
                paginationDisplayRows: '',
                jumpToPage: 0,
                customPerPageArr: ['25', '50', '100', '200', '500'],

                permissions: [],
                cantAccessPage: true,
                message: 'all',
                isLoggedIn: false,
                firstLoad: 0,
                columns: [
                    // {
                    //     label: 'Collector',
                    //     field: 'user_first_name',
                    //     filterable: true,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Collector", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Contact Name',
                     field: 'contact_name',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Contact Name", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Contact Number',
                        field: 'contact_phone',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Email',
                        field: 'contact_email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },

                    {
                        label: 'Customer Type',
                        field: 'customer_type',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Type", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        tdClass: 'fliter-class',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterDropdownItems: ['Active', 'Inactive'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Description',
                     field: 'description',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Description", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Created Date',
                        field: 'excede_created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Updated Date',
                        field: 'excede_updated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                    }

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'cusid',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                },
            }),

        mounted: function () {
            var self = this;
            /* Apply stored filters start */
            self.loadFilters('menucustomers', self.columns, self.serverParams, 'customerList');
            /*var userObj = localStorage.getItem('filters');
             if (userObj != null) {
             userObj = JSON.parse(userObj);
             if (userObj.menucustomers != null) {
             self.serverParams.columnFilters = userObj.menucustomers;
             $.map(userObj.menucustomers, function (val, key) {
             $.each(self.columns, function (i) {
             if (self.columns[i].field == key && val != '') {
             self.columns[i].filterOptions.filterValue = val;
             }
             });
             });
             }
             }*/
            self.jumpToPage = self.serverParams.page;
            self.pageCompare = Math.ceil(self.displayPage / 2);
            $("#jumpToPage").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPage(self.jumpToPage)
                }
            });
            /* Apply stored filters end */
            self.showLoader();
            self.loadCustomers();

            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        methods: {
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            changedValue: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPage: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberList()) {
                    pageNumber = self.pageNumberList();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPage).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClick(pageNumber);
            },
            onPerticularPageClick: function (pageNumber) {
                var self = this;
                self.serverParams.page = pageNumber;
                self.jumpToPage = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1 && self.jumpToPage != 1){
                    self.loadCustomers();
                } else if(self.firstLoad == 1 && self.jumpToPage >=1) {
                    self.loadCustomers();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberList: function () {
                var self = this;
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            changedValueCustomPerPage: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1){
                    self.jumpToInputPage(self.serverParams.page);
                    self.loadCustomers();
                }
                /* Single Backend Call on page load end */
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_customer_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            customFilter(params) {
                //console.log(params);
            },
            updateParams(newProps) {

                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCustomers();
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadCustomers();
            },

            onColumnFilter(params) {

                this.updateParams(params);
                {
                    field: ('first_name');
                    field: ('contact_name');
                    field: ('contact_phone');
                    field: ('contact_email');
                    field: ('description');
                    field: ('cusid');
                    field:('customer_type');
                    field:('description');
                    field:('created_at');
                }
                ;
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.first_name || filters.contact_name || filters.contact_phone || filters.contact_email
                        || filters.user_first_name || filters.cusid || filters.created_at || filters.customer_type
                        || filters.description) {
                    this.loadCustomers();
                }

            },
            onSortChange(params) {
                /* console.log(JSON.stringify(params));
                return; */
                this.updateParams({
                    sort: {
                        /* type: params.sortType,
                        field: this.columns[params.columnIndex].field, */
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadCustomers();
            },
            onRowClick(params) {
                var id = params.row.id;
                var self = this;
                self.$router.push({path: `/customer/view/${id}`});
            },
            // selectionChanged(){

            // },
            //edit rental page
            allClickCustomer: function () {
                var self = this;
                self.message = 'all';
                self.loadCustomers();
            },
            myClickCustomer: function () {
                var self = this;
                self.message = 'my';
                self.serverParams.page = 1;
                self.jumpToPage = 1;
                self.loadCustomers();
            },
            refreshCustomer() {
              // console.log("REFERSH DATA  refetch_customer");
              var self = this;
              self.showLoader();
              $.ajax({
                    url: process.env.ROOT_API + "/refetch_customer",
                    type: "GET",
                    data: {},
                    headers: {
                        'Accept': 'application/json',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                      self.hideLoader();
                        if (data.code == '200') {

                          Swal.fire({
                                type: 'success',
                                title: 'Success',
                                html: "Sync EXCEDE Customer Successfully",
                                showConfirmButton: true,
                            });
                            self.loadCustomers();
                        }

                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            loadCustomers: function () {
                var self = this;
                self.serverParams.setCurrentPage = self.serverParams.page;
                if (self.message == 'my') {
                    self.toggleButtons(self.message, 'btn_my_cust', 'btn_all_cust');
                } else {
                    self.toggleButtons(self.message, 'btn_all_cust', 'btn_my_cust');
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };
                self.storeFilters('menucustomers', self.serverParams, false);
                this.firstLoad = 1;
                //console.log(self.serverParams.columnFilters);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/list_customer",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.showHidePagination("customerList", self.totalRecords);
                            self.jumpToPage = self.serverParams.page;
                        }
                        self.paginationDisplayRows = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },

            // addrate: function(){
            //     var self = this;
            //
            //     self.$router.push("/addrate");
            // }
            addCustomer() {
                var self = this;
                self.$router.push("/customerform")
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/customer/ListCustomerComponent.vue